import React from 'react';
import { clsx } from 'clsx';
import classes from './Pagehead.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import Box from '../Box/Box.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Pagehead = ({
  className,
  sx: sxProp = defaultSxProp,
  ...rest
}) => {
  if (sxProp !== defaultSxProp || rest.as) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      sx: sxProp,
      className: clsx(classes.Pagehead, className)
    }, rest));
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(classes.Pagehead, className)
  }, rest));
};
Pagehead.displayName = "Pagehead";

export { Pagehead as default };
